/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddonProvisionProjectRequestOneOf
 */
export interface AddonProvisionProjectRequestOneOf {
    /**
     * 
     * @type {string}
     * @memberof AddonProvisionProjectRequestOneOf
     */
    addonType: string;
    /**
     * 
     * @type {string}
     * @memberof AddonProvisionProjectRequestOneOf
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof AddonProvisionProjectRequestOneOf
     */
    projectId: string;
}

/**
 * Check if a given object implements the AddonProvisionProjectRequestOneOf interface.
 */
export function instanceOfAddonProvisionProjectRequestOneOf(value: object): value is AddonProvisionProjectRequestOneOf {
    if (!('addonType' in value) || value['addonType'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    return true;
}

export function AddonProvisionProjectRequestOneOfFromJSON(json: any): AddonProvisionProjectRequestOneOf {
    return AddonProvisionProjectRequestOneOfFromJSONTyped(json, false);
}

export function AddonProvisionProjectRequestOneOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddonProvisionProjectRequestOneOf {
    if (json == null) {
        return json;
    }
    return {
        
        'addonType': json['addonType'],
        'token': json['token'],
        'projectId': json['projectId'],
    };
}

export function AddonProvisionProjectRequestOneOfToJSON(json: any): AddonProvisionProjectRequestOneOf {
    return AddonProvisionProjectRequestOneOfToJSONTyped(json, false);
}

export function AddonProvisionProjectRequestOneOfToJSONTyped(value?: AddonProvisionProjectRequestOneOf | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addonType': value['addonType'],
        'token': value['token'],
        'projectId': value['projectId'],
    };
}

